<de-footer [showSlogan]="true" [links]="footerLinks"></de-footer>